/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Zahlungausgesetztab2Inputs */

const de__field_zahlungausgesetztab2 = /** @type {(inputs: _Field_Zahlungausgesetztab2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zahlung ausgesetzt ab`)
};

/**

* @param {_Field_Zahlungausgesetztab2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_zahlungausgesetztab2 = /** @type {((inputs?: _Field_Zahlungausgesetztab2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Zahlungausgesetztab2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_zahlungausgesetztab2(inputs)
});
export { _field_zahlungausgesetztab2 as "_field_zahlungAusgesetztAb" }